/* import __COLOCATED_TEMPLATE__ from './locale-option-without-state-badge.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();